import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getSubPage, hasError } from '../../../states/page/selectors';
import AddNewPayeeLandingPage from '../AddNewPayeeLandingPage';
import AddNewPayeeSuccessPage from '../AddNewPayeeSuccessPage';
import EditPayee from '../../../managePayee/components/editPayee';
import EditChaps from '../../../managePayee/components/editChaps';
import { getPaymentTypeOrPayeeType } from '../../../states/modes/selectors';
import { getPayeeIds } from '../../../states/payees/selectors';

const mapState = (state) => ({
	page: getSubPage(state),
	hasError: hasError(state),
	paymentTypeOrPayeeType: getPaymentTypeOrPayeeType(state),
	payeeIds: getPayeeIds(state),
});

class LayoutContainer extends Component {
	constructor(props) {
		super(props);
		this.handleNowMakeAPaymentClick = this.handleNowMakeAPaymentClick.bind(this);
	}

	componentDidUpdate() {
		const { handleRoute, hasError } = this.props;
		if (hasError) {
			handleRoute('WEB-ERROR');
		}
	}

	componentWillUnmount() {
		const { fetchParentBeneficiary = () => {} } = this.context;
		fetchParentBeneficiary();
	}

	handleNowMakeAPaymentClick() {
		const { gotToMoveMoneyPage } = this.props;
		return gotToMoveMoneyPage(true);
	}

	render() {
		const {
			copCheckTriggered,
			page,
			handleRoute,
			paymentTypeOrPayeeType,
			hasError,
			payeeIds: { addPayeeId, editPayeeId },
			sessionCOPChecks,
		} = this.props;

		switch (page) {
			case 'Add':
				return (
					<div className="container container--lg">
						<AddNewPayeeLandingPage
							copCheckTriggered={copCheckTriggered}
							id={addPayeeId}
							paymentTypeOrPayeeType={paymentTypeOrPayeeType}
							hasError={hasError}
							sessionCOPChecks={sessionCOPChecks}
						/>
					</div>
				);
			case 'Edit':
				return (
					<div className="container container--lg">
						<EditPayee copCheckTriggered={copCheckTriggered} id={editPayeeId} sessionCOPChecks={sessionCOPChecks} />
					</div>
				);
			case 'Success':
				return (
					<div className="container container--lg">
						<AddNewPayeeSuccessPage
							handleRoute={handleRoute}
							handleNowMakeAPaymentClick={this.handleNowMakeAPaymentClick}
						/>
					</div>
				);
			case 'Chaps':
				return (
					<div className="container container--lg">
						<EditChaps id={editPayeeId} />
					</div>
				);
			default:
				return null;
		}
	}
}

LayoutContainer.propTypes = {
	page: PropTypes.string.isRequired,
	hasError: PropTypes.bool,
	handleRoute: PropTypes.func.isRequired,
	gotToMoveMoneyPage: PropTypes.func,
	paymentTypeOrPayeeType: PropTypes.string.isRequired,
	payeeIds: PropTypes.shape({
		addPayeeId: PropTypes.string.isRequired,
		editPayeeId: PropTypes.string.isRequired,
	}).isRequired,
};
LayoutContainer.contextTypes = {
	fetchParentBeneficiary: PropTypes.func,
};

export { LayoutContainer };

export default connect(mapState)(LayoutContainer);
